import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-pause-circle",
  templateUrl: "./med-icon-pause-circle.component.html",
})
export class MedIconPauseCircleComponent extends SvgMixinComponent {}
